import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#hot', label: '今日热榜' },
  { href: '#cats', label: '瓜圈分类' },
  { href: '#fresh', label: '最新鲜瓜' },
  { href: '#crowd', label: '粉丝来稿' },
  { href: '#faq', label: '玩法问答' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 items-center justify-between gap-4 px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2 group" aria-label="吃瓜日报首页">
          <span className="flex h-8 w-8 md:h-9 md:w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-vip-crown-fill text-lg md:text-xl" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-xl md:text-2xl font-black tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-500">日报</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-primary-600"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-2 lg:flex">
          <a
            href="#hot"
            className="whitespace-nowrap inline-flex items-center justify-center gap-1.5 rounded-md px-3 py-2 text-sm font-medium text-primary-600 hover:bg-primary-50"
          >
            <i className="ri-fire-fill" aria-hidden="true"></i>热榜
          </a>
          <a
            href="#submit"
            className="whitespace-nowrap inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-send-plane-fill" aria-hidden="true"></i>投稿爆料
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 lg:hidden"
          aria-label="展开导航菜单"
          aria-expanded={open}
        >
          <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-3-line text-2xl'} aria-hidden="true"></i>
        </button>
      </div>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden">
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-md px-3 py-3 text-sm font-medium text-foreground-700 hover:bg-background-200/70 hover:text-primary-600"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-md bg-primary-500 px-4 py-3 text-sm font-semibold text-background-50"
            >
              <i className="ri-send-plane-fill" aria-hidden="true"></i>投稿爆料
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}